import { types } from '../../../../utils/settings';

export const visjsGraphOptions = {
  manipulation: {
    enabled: false
  },
  physics: {
    enabled: true,
    barnesHut: {
      theta: 0.5,
      gravitationalConstant: -50000,
      springLength: 200,
      springConstant: 0.006,
      centralGravity: 1.5,
      damping: 0.09,
      avoidOverlap: 1
    },
    timestep: 1,
    minVelocity: 5,
    stabilization: {
      fit: true
    }
  },
  interaction: {
    hover: true,
    tooltipDelay: 200,
    multiselect: true,
    navigationButtons: false,
    keyboard: false
  },
  layout: {
    randomSeed: 3
  },
  nodes: {
    shape: 'image',
    image: '/graph/circle-solid-gamboge.png',
    brokenImage: '/graph/circle-solid-gamboge.png',
    mass: 1.2,
    size: 20,
    labelHighlightBold: true,
    font: {
      face: 'arial',
      color: '#F3F6F7',
      size: 18,
      //bold: true,
      //background: '#303253',
      strokeWidth: 5,
      strokeColor: "#202020",
    },
    color: {
      background: 'rgba(0, 0, 0, 0)',
      border: 'rgba(0, 0, 0, 0)',
      hover: 'rgba(0, 0, 0, 0)',
      highlight: {
        background: 'rgba(0, 196, 255, 0.5)',
        border: 'rgba(0, 196, 255, 1)',
      }
      //background: '#282840',
      //border: '#282840',
      //highlight: {
      //  background: '#303253',
      //  border: '#303253',
      //},
      //hover: {
      //  background: '#303253',
      //  border: '#303253',
      //}
    },
    chosen: {
      node: function(values, id, selected, hovering) {
        if (selected) {
          //values.shadowColor = '#b3daff';
          //values.shadowSize = 30;
          //values.shadowX = 0;
          //values.shadowY = 0;
        }
      },
      label: function(values, id, selected, hovering) {
        if (selected) {
          values.mod = 'bold';
          values.color = '#ffffff';
          values.strokeWidth = 5;
          values.strokeColor = '#003a4b';
        }
      }
    },
    shapeProperties: {
      useBorderWithImage: true
    },
    shadow: {
      enabled: true,
      color: '#1a1b33'
    }
  },
  edges: {
    width: 1,
    arrows: 'to',
    color: {
      color: 'rgba(243,246,247,0.5)',
      //highlight: '#F3F6F7',
      //hover: '#F3F6F7'
    },
    font: {
      face: 'arial',
      size: 14,
      color: '#F3F6F7',
      strokeColor: '#303253',
      //background: '#303253'
    }
  },
  groups: {
    useDefaultGroups: false
    // will be filled below, from settings.js -> types
  }
};

for (const type in types) {
  const imgUrl = types[type].graph;
  if (imgUrl) {
    visjsGraphOptions.groups[type] = {
      image: imgUrl
    }
  }
}
